// Wrapper de API para CRUD de usuários do Hub (PO1-2020).
// Endpoints servidos pelo backend_hub.

import api from "./api";

// Filtro `idEmbarcador` (opcional) é respeitado apenas para admin Everlog
// no backend. Embarcador comum sempre tem o filtro forçado pelo JWT.
export async function listUsers({ idEmbarcador, includeDeleted } = {}) {
  const params = { _ts: Date.now() };
  if (idEmbarcador !== null && idEmbarcador !== undefined) {
    params.embarcadorId = idEmbarcador;
  }
  if (includeDeleted) {
    params.includeDeleted = true;
  }
  const { data } = await api.get("/users", { params });
  return data;
}

export async function getUser(id) {
  const { data } = await api.get(`/users/${id}`);
  return data;
}

export async function createUser({ name, surname, email, userName }) {
  const { data } = await api.post("/users", { name, surname, email, userName });
  return data;
}

export async function updateUser(id, { name, surname, email, userName }) {
  const { data } = await api.put(`/users/${id}`, {
    name,
    surname,
    email,
    userName,
  });
  return data;
}

export async function setUserActive(id, isActive) {
  const { data } = await api.patch(`/users/${id}/active`, { isActive });
  return data;
}

// PO1-2047 — soft-delete / restauração de usuário
export async function deleteUser(id) {
  const { data } = await api.delete(`/users/${id}`);
  return data;
}

export async function restoreUser(id) {
  const { data } = await api.post(`/users/${id}/restore`);
  return data;
}

// Aceita objeto compatível com PO1-2021:
//   { password }               — senha manual
//   { randomPassword: true }   — backend gera e retorna em texto claro
//   { mustChangeOnNextLogin }  — flag opcional
//
// Backward-compat: se chamado com (userId, "abc"), encaminha como password manual.
export async function setUserPassword(userId, opts) {
  const payload =
    typeof opts === "string" ? { password: opts } : { ...opts };
  const { data } = await api.post("/users/save-password", {
    userId,
    ...payload,
  });
  return data;
}

// PO1-2024 — vínculo user ↔ role (groups)
export async function getUserGroups(userId) {
  const { data } = await api.get(`/users/${userId}/groups`);
  return data;
}

export async function setUserGroups(userId, roleIds) {
  const { data } = await api.put(`/users/${userId}/groups`, { roleIds });
  return data;
}

// User-level permission overrides
export async function getUserPermissionOverrides(userId) {
  const { data } = await api.get(`/users/${userId}/permissions`);
  return data;
}

export async function setUserPermissionOverrides(userId, { granted, revoked }) {
  const { data } = await api.put(`/users/${userId}/permissions`, {
    granted: granted || [],
    revoked: revoked || [],
  });
  return data;
}

// PO1-2022 — convite por e-mail
export async function sendActivationEmail(userId, baseUrl) {
  const { data } = await api.post(`/users/${userId}/send-activation`, {
    baseUrl: baseUrl || window.location.origin,
  });
  return data;
}

export async function confirmActivation(token, novaSenha) {
  const { data } = await api.post("/auth/activation/confirm", {
    token,
    novaSenha,
  });
  return data;
}

// PO1-2023 — classificação (admin / embarcador / transportadora)
export async function listClassificacaoOptions() {
  const { data } = await api.get("/classificacao/options");
  return data;
}

export async function getUserClassificacao(userId) {
  const { data } = await api.get(`/users/${userId}/classificacao`);
  return data;
}

export async function setUserClassificacao(userId, payload) {
  const { data } = await api.put(`/users/${userId}/classificacao`, payload);
  return data;
}
